import './bootstrap';
import './sentry';
document.addEventListener('livewire:init', () => {
    Livewire.on('scrollTop', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
});
